import { quickProperty, designToken } from '../component-tokens';
import { nameWithSize, sizeAttributes } from './utils';
import { borderBase, focusState } from './common';
const avatarAttrs = Object.assign(Object.assign({}, sizeAttributes('2.25rem')), { '--goto-icon-size': quickProperty('1.5rem'), 'border-radius': quickProperty('50%'), display: quickProperty('flex'), 'align-items': quickProperty('center'), 'justify-content': quickProperty('center'), 'flex-shrink': quickProperty('0'), 'user-select': quickProperty('none'), outline: quickProperty('0'), font: designToken('avatar-medium'), position: quickProperty('relative'), 'text-align': quickProperty('center') });
const icon = {
    alias: 'avatar-icon',
    name: 'icon',
    attributes: {
        width: quickProperty('1.875rem'),
        'pointer-events': quickProperty('none'),
    },
};
const image = {
    name: 'picture',
    attributes: Object.assign(Object.assign({}, sizeAttributes('100%')), { 'border-radius': quickProperty('50%') }),
};
const states = [
    {
        alias: 'avatar-focus',
        name: 'focus',
        attributes: Object.assign(Object.assign({}, borderBase), focusState),
    },
];
const avatarSize = (name, size, svgSize) => (Object.assign(Object.assign({}, nameWithSize(name, `${size}px`, {
    font: designToken(`avatar-${size}`),
    '--goto-icon-size': quickProperty(svgSize),
})), { children: [
        Object.assign(Object.assign({}, nameWithSize('icon', svgSize)), { alias: `avatar-${name}-icon` }),
    ] }));
export const avatarTokens = {
    name: 'avatar',
    reactImports: 'Avatar, AvatarGroup',
    tag: 'chameleon-avatar',
    attributes: avatarAttrs,
    sizes: [
        avatarSize('xsmall', 24, '1rem'),
        avatarSize('small', 30, '1.25rem'),
        avatarSize('medium', 40, '1.5rem'),
        avatarSize('large', 48, '2rem'),
        avatarSize('xlarge', 64, '2.75rem'),
        avatarSize('xxlarge', 80, '3.25rem'),
        avatarSize('xxxlarge', 180, '7.25rem'),
    ],
    variants: [
        {
            name: 'with-svg',
            states,
            children: [
                Object.assign(Object.assign({}, icon), { attributes: Object.assign(Object.assign({}, icon.attributes), { color: designToken('type-color-inverted') }) }),
            ],
        },
        {
            name: 'with-image',
            states,
            children: [image],
        },
        {
            name: 'with-text',
            states,
            children: [
                {
                    name: 'initials',
                    tag: 'span',
                    attributes: {
                        color: designToken('type-color-inverted'),
                        font: designToken('button-medium'),
                    },
                },
            ],
        },
    ],
};
